export default "__VITE_ASSET__bvcx3UvC__"